import * as addMmsTemplate from '../services/addMmsTemplate';

export default {
  namespace: 'addMmsTemplate',

  state: {
    isAddSuccess: null,
    signatureList: [],
    mmsDefaultValues: null,
  },

  effects: {
    *handleAddTempMsg({ payload: { values }, callback }, { call, put }) {
      const response = yield call(addMmsTemplate.handleAddTempMsg, values);
      yield put({
        type: 'save',
        payload: {
          isAddSuccess: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *handleUpdateTempMsg({ payload: { values }, callback }, { call, put }) {
      const response = yield call(addMmsTemplate.handleUpdateTempMsg, values);
      yield put({
        type: 'save',
        payload: {
          isAddSuccess: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *getTempMsgDetail({ payload: { values } }, { call, put }) {
      const res = yield call(addMmsTemplate.getSignatureList, values);
      yield put({
        type: 'save',
        payload: {
          signatureList: res?.data,
        },
      });
      if (!values.id) {
        return false;
      }
      const response = yield call(addMmsTemplate.getTempMsgDetail, values);
      const data = response.data;
      let f = data.filePath;
      if (f?.length > 0) {
        f = f.map((item)=> {
          return `${item.url}`;
        });
      }
      yield put({
        type: 'save',
        payload: {
          mmsDefaultValues: {...data, filePath:f},
        },
      });
    },
    *getSignatureList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(addMmsTemplate.getSignatureList, values);
      yield put({
        type: 'save',
        payload: {
          signatureList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *postPreview({ payload: { values }, callback }, { call }) {
      const response = yield call(addMmsTemplate.postPreview, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *getTempMsgVariableList({ payload: { values } }, { call, put }) {
      const response = yield call(addMmsTemplate.getTempMsgVariableList, values);
      yield put({
        type: 'save',
        payload: {
          tempMsgVariableList: response.data,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen((props) => {
        if (
          props.pathname.includes('/addMmsTemplate')
        ) {
          dispatch({
            type: 'save',
            payload: {
              mmsDefaultValues: null,
            },
          });
        }
      });
    },
  },
};
